var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisplaynamev2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.331,
    height: 16.4,
    viewBox: "0 0 35.331 16.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31531",
    "data-name": "Rectangle 31531",
    width: 15.778,
    height: 16.4,
    transform: "translate(0 0)",
    fill: "#3c3c3b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14149",
    "data-name": "Group 14149",
    transform: "translate(-351 -738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14148",
    "data-name": "Group 14148",
    transform: "translate(370.552 738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12672",
    "data-name": "Group 12672",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38484",
    "data-name": "Path 38484",
    d: "M21.334,3.928A3.928,3.928,0,1,1,17.406,0a3.928,3.928,0,0,1,3.928,3.928",
    transform: "translate(-9.517 0)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38485",
    "data-name": "Path 38485",
    d: "M10.648,28.516a4.685,4.685,0,0,1-5.518,0A9.78,9.78,0,0,0,.061,34.858c-.237.812.243,1.677.921,1.677H14.8c.679,0,1.159-.865.921-1.677a9.779,9.779,0,0,0-5.069-6.342",
    transform: "translate(0 -20.135)",
    fill: "#3c3c3b"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31800",
    "data-name": "Rectangle 31800",
    width: 17,
    height: 3,
    rx: 1.5,
    transform: "translate(351 739)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31801",
    "data-name": "Rectangle 31801",
    width: 17,
    height: 3,
    rx: 1.5,
    transform: "translate(351 745)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31802",
    "data-name": "Rectangle 31802",
    width: 17,
    height: 3,
    rx: 1.5,
    transform: "translate(351 751)",
    fill: "#3c3c3b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplaynamev2);
export default __webpack_public_path__ + "static/media/Display name v2.72d3c2a72fc4ee9e45780c8d0fcd9efa.svg";
export { ForwardRef as ReactComponent };